import React, { useEffect, useState } from "react";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import Loader from "../../Components/Common/Loader";
import { Modal } from "react-bootstrap";
import { Constants } from "../../CommonMethhods/Constants";
import * as CryptoJS from "crypto-js";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import {
  AESEncryption,
  ApiResDecrypt,
  encryptPayloadValues,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import axiosInstance, { axiosMultipartInstance } from "../../CommonMethhods/axiosInstance";

function IncomeDeclartionSidebar() {
  const storeToken = localStorage.getItem("ssoToken");
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [clientListData, setClientListData] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [count, setCount] = useState();
  const [errorState, setErrorState] = useState(false);
  const [selectCode, setSelectCode] = useState();
  const [foYesNo, setFoYesNo] = useState("");

  //useForm start

  const MAX_FILE_SIZE = 1048576 * 10; //100KB

  const AllowedFormat = ["jpg", "docx", "doc", "pdf", "png", "jpge"];

  function isValidFileType(fileName) {
    if (fileName && fileName.length > 0) {
      //   return false;
      let docName = fileName[0].name;
      let ExtNameArray = docName.split(".");
      let ExtName = ExtNameArray[ExtNameArray.length - 1];
      if (AllowedFormat.includes(ExtName)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  function isValidSize(fileName) {
    if (fileName && fileName.length > 0) {
      if (fileName[0].size <= MAX_FILE_SIZE) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  const incomeRangeSchema = Yup.object()
    .shape({
      incomeRangeValid: Yup.string().required().nullable(),

      iAgreeStatment: Yup.boolean().required().nullable(),
    })
    .when((value, schema) => {
      if (foYesNo === "Y") {
        return schema.shape({
          incomeProof: Yup.string().required().nullable(),
          fileUpload: Yup.mixed()
            .test(
              "Added Image",
              "*Mandatory to select File",
              (value) => value.length > 0
            )
            .test(
              "is-valid-type",
              "*Only pdf/jpge/png/doc/docx files are allowed to upload",
              (value) => {
                return isValidFileType(value);
              }
            )
            .test(
              "is-valid-size",
              "*Please select file less than 10MB",
              (value) => {
                return isValidSize(value);
              }
            ),
        });
      }
    });

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    setError,
    reset,
    watch,
    clearErrors,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(incomeRangeSchema),
  });
  //useForm End

  const getClientListIncomeRange = async (page = 1) => {
    if (page === 1) {
      setLoader(true);
    }
    let payloadValue = { pageNo: page, pageSize: 10 };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getData = await axiosInstance.post(
        Dashboard_Client_Report.IncomeRangeProof_Report_URL,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getData?.data);

      setErrorState(false);
      if (res?.status === 0) {
        setCount(res?.data?.totalCount);
        if (pageNo > 1) {
          setClientListData((prev) => {
            return [...prev, ...res?.data?.clntList];
          });
        } else {
          setClientListData(res?.data?.clntList);
        }
      }
    } catch (error) {
      console.log(error);
      setClientListData([]);
      setErrorState(error.message);
    } finally {
      setLoader(false);
      setScrollLoader(false);
    }
  };

  const handleScrollClientList = (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (!(count <= 10 * pageNo)) {
        setPageNo((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };

  useEffect(() => {
    getClientListIncomeRange(pageNo);
  }, [pageNo]);

  const openUpdateModal = (code, fo) => {
    setModalOpen(true);
    setFoYesNo(fo);
    setSelectCode(code);
  };
  const onHide = () => {
    setModalOpen(false);
    reset();
    clearErrors();
  };
  const incomeDeclarationData = async (data, incomeR) => {
    const storeToken = localStorage.getItem("ssoToken");
  
    try {
      const payload = {
        clientCode: selectCode,
        incomeRange: incomeR,
        agree: data.iAgreeStatment,
        documentType: foYesNo === "Y" && data.fileUpload?.length > 0 ? data.incomeProof : "",
        IncomeFile: foYesNo === "Y" && data.fileUpload?.length > 0 ? data.fileUpload[0] : "",
      };
      // console.log(payload, "payload");
      const encryptedPayload = encryptPayloadValues(payload);
      const formData = new FormData();
      Object.entries(encryptedPayload).forEach(([key, value]) => {
        formData.append(key, value);
      });
      const declarationData = await axiosMultipartInstance.post(
        Dashboard_Client_Report.IncomeDeclaration_Report_URL,
        formData,
        // {
        //   headers: {
        //     "Content-Type": "multipart/form-data",
        //     Authorization: `Bearer ${storeToken}`,
        //   },
        // }
      );
      const res = ApiResDecrypt(declarationData?.data);
      if (res?.status === 0) {
        toast.success(`${res?.data?.message} for ${selectCode}`);
        setModalOpen(false);
        clearErrors();
        reset();
        setTimeout(() => {
          getClientListIncomeRange(1);
          setClientListData([]);
        }, 1000);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };
  
 
  
  // const incomeDeclarationData = async (data, incomeR) => {
  //   const storeToken = localStorage.getItem("ssoToken");

  //   try {
  //     const formData = new FormData();
  //     formData.append("clientCode", selectCode);
  //     formData.append("incomeRange", incomeR);
  //     formData.append("agree", data.iAgreeStatment);
  //     formData.append("documentType", foYesNo === "Y" ? data.incomeProof : "");
  //     formData.append("IncomeFile", foYesNo === "Y" ? data.fileUpload[0] : "");

  //     const declarationData = await axios.post(
  //       Dashboard_Client_Report.IncomeDeclaration_Report_URL,
  //       formData,

  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //           Authorization: `Bearer ${storeToken}`,
  //         },
  //       }
  //     );
  //     const res = declarationData?.data;
  //     if (res?.status === 0) {
  //       toast.success(`${res?.data?.message} for ${selectCode}`);
  //       setModalOpen(false);
  //       clearErrors();
  //       reset();
  //       setTimeout(() => {
  //         getClientListIncomeRange(1);
  //         setClientListData([]);
  //       }, 1000);
  //     } else {
  //       toast.error(res?.message);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  const OnFinalSubmit = (data) => {
    let CurrentRange = data.incomeRangeValid;
    let IncomeRange;

    if (CurrentRange === "below 1 lakh") {
      IncomeRange = "below 1 lakh";
    }

    if (CurrentRange === "1-5 lakh") {
      IncomeRange = "1-5 lakh";
    }

    if (CurrentRange === "5-10 lakh") {
      IncomeRange = "5-10 lakh";
    }

    if (CurrentRange === "10-25 lakh") {
      IncomeRange = "10-25 lakh";
    }
    if (CurrentRange === "more than 25 lakh") {
      IncomeRange = "more than 25 lakh";
    }
    if (data.iAgreeStatment) {
      incomeDeclarationData(data, IncomeRange);
    } else {
      setError("iAgreeStatment", {
        type: true,
        message: "*You must agree to Declaration before submitting the form",
      });
    }
  };

  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content">
        <div className="card-box">
          <div>
            <h2 className="h2-css-all">
              {Constants.List_Of_Income_Not_Updated}
            </h2>
          </div>

          <div className="for-grid-section">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : (
              <div className="scroll-table income-report">
                {clientListData && clientListData.length > 0 ? (
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Sr No.</th>
                        <th>Client Code</th>
                        <th>Client Name</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>

                    <tbody onScroll={(e) => handleScrollClientList(e)}>
                      {clientListData?.map((item, key) => {
                        return (
                          <tr key={key}>
                            <td>{key + 1}.</td>
                            <td>{item?.clientCode || "-"}</td>
                            <td>{item?.clientName || "-"}</td>
                            <td>
                              <button
                                type="button"
                                className="income-update-btn"
                                onClick={() => {
                                  openUpdateModal(item?.clientCode, item?.fo);
                                }}
                              >
                                {Constants.Update}
                                <span className="icon-Edit edit-icon"></span>
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                      {scrollLoader && (
                        <div className="loader-center">
                          <LoaderForSearch />
                        </div>
                      )}
                    </tbody>
                  </table>
                ) : (
                  !errorState && (
                    <div className="report-error-message">
                      {noDataFound("No Income Proof Details Available")}
                    </div>
                  )
                )}
                {errorState && (
                  <div className="report-error-message">
                    {noDataFound(errorState)}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </main>

      <Modal
        show={modalOpen}
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={`setting-model  ${foYesNo === "N" ? "income-verticle-modal" : "income-declartion-model"
          }`}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <h2>{Constants.Attention_Required}</h2>
            <p>{Constants.As_Per_Regulatory_Account_Suspended}</p>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onHide}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(OnFinalSubmit)}>
            <div className={`row ${foYesNo === "N" ? "row-verticle" : ""}`}>
              <div
                className={`${foYesNo === "N" ? "col-md-12" : "col-md-6"
                  } left-content`}
              >
                <div className="title-content">
                  {Constants.Select_Your_Income_Range}
                </div>
                <div className="modal-clientCode">
                  <p>Client Code</p>
                  <p>{selectCode}</p>
                </div>
                <ul>
                  <li>
                    <label htmlFor="0to1Lakhs">{Constants.Below1Lac}</label>
                    <input
                      type="radio"
                      name="amount"
                      value="below 1 lakh"
                      {...register("incomeRangeValid")}
                      onClick={() => {
                        setValue("incomeRangeValid", "below 1 lakh");
                      }}
                    />
                  </li>
                  <li>
                    <label>{Constants.OneTo5}</label>
                    <input
                      type="radio"
                      name="amount"
                      value="1-5 lakh"
                      {...register("incomeRangeValid")}
                      onClick={() => {
                        setValue("incomeRangeValid", "1-5 lakh");
                      }}
                    />
                  </li>
                  <li>
                    <label>{Constants.FiveTo10}</label>
                    <input
                      type="radio"
                      name="amount"
                      value="5-10 lakh"
                      {...register("incomeRangeValid")}
                      onClick={() => {
                        setValue("incomeRangeValid", "5-10 lakh");
                      }}
                    />
                  </li>
                  <li>
                    <label>{Constants.TenTo25}</label>
                    <input
                      type="radio"
                      name="amount"
                      value="10-25 lakh"
                      {...register("incomeRangeValid")}
                      onClick={() => {
                        setValue("incomeRangeValid", "10-25 lakh");
                      }}
                    />
                  </li>
                  <li>
                    <label>{Constants.MoreThan25}</label>
                    <input
                      type="radio"
                      name="amount"
                      value="more than 25 lakh"
                      {...register("incomeRangeValid")}
                      onClick={() => {
                        setValue("incomeRangeValid", "more than 25 lakh");
                      }}
                    />
                  </li>
                </ul>
                {errors.incomeRangeValid?.type === "required" && (
                  <div className="text-danger incomerange-error">
                    *Mandatory to select Income Range
                  </div>
                )}
              </div>
              <div
                className={`${foYesNo === "N" ? "col-md-12" : "col-md-6"
                  } right-content`}
              >
                {foYesNo === "Y" && (
                  <>
                    <div className="select-parent">
                      <select
                        className="select-income-dropdown"
                        {...register("incomeProof")}
                      >
                        <option value="">-- Select --</option>
                        <option value="upload holding statement">
                          {Constants.Statement_Demat_Holdings}
                        </option>
                        <option value="bank account statement for the last 6 month">
                          {Constants.Statement_last_6_Months}
                        </option>
                        <option value="the latest salary slip">
                          {Constants.Latest_Salary_Slip}
                        </option>
                        <option value="copy of itr acknowledgement">
                          {Constants.Copy_Of_ITR_Acknowledgement}
                        </option>
                        <option
                          value="copy of form 16 in case of salary
                        income"
                        >
                          {Constants.Copy_Form_16_salary}
                        </option>
                        <option value="net worth certificate">
                          {Constants.Net_Worth_Certificate}
                        </option>
                      </select>
                      <span>{Constants.Upload_Your_Income_Proof}</span>
                      {errors.incomeProof?.type === "required" && (
                        <div className="text-danger incomeProof-error">
                          *Mandatory to select Income Proof
                        </div>
                      )}
                    </div>
                    <div className="file-upload">
                      <input
                        type="file"
                        {...register("fileUpload")}
                        className="upload-file"
                        accept=".doc,.docx,.jpg,.pdf,.png,.jpge"
                      />
                      <div className="text-danger incomeProof-error">
                        {errors?.fileUpload?.message}
                      </div>
                      {/* <p className="choose-file">Please choose pdf/jpge/png/doc/docx files</p> */}
                    </div>
                  </>
                )}

                <div className="right-bottom">
                  <div className="title-content">{Constants.Declaration}</div>
                  <p>{Constants.Call_For_Any_Documents}</p>
                  <div className="agree-group">
                    <input
                      type="checkbox"
                      name="agree"
                      {...register("iAgreeStatment")}
                    />

                    <label>{Constants.I_Agree}</label>
                  </div>
                  {errors.iAgreeStatment?.type && (
                    <div className="text-danger incomeProof-error">
                      {errors.iAgreeStatment.message}
                    </div>
                  )}
                  <div className="btn-wrapper">
                    <button type="submit">SUBMIT</button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default IncomeDeclartionSidebar;
